<app-popup-layout #modal>
  <header class="modal-header">
    <app-close-button
      class="ms-auto"
      (onCloseEmitter)="modal.dismiss()"
    ></app-close-button>
  </header>
  <div class="modal-container">
    <img
      src="assets/home/meal-card-background.png"
      class="meal-card-contact"
      alt="Card"
    />
    <section class="d-flex flex-column">
      <section
        style="padding-top: 15px"
        class="align-items-center d-flex flex-column justify-center mx-24 info"
      >
        <p class="title mb-8">
          Thank you for showing interest in “Meal Cards” with EnKash.
        </p>
        <p class="sub-title mb-8">
          EnKash team will reach out to you shortly for the Meal Card setup
        </p>

        <p class="sub-title mb-16">
          To expedite your inquiry, write to us at
          <a
            class="email-link"
            [href]="'mailto:' + 'meals@enkash.com'"
            target="_top"
            >support&#64;enkash.com</a
          >
        </p>

        <button
          mat-flat-button
          color="primary"
          class="custom-button-submit"
          (click)="modal.dismiss()"
        >
          Okay
        </button>
      </section>
      <img
        src="assets/home/meal-card-footer-design.png"
        class="footer-design mt-auto"
        alt="Card"
      />
    </section>
  </div>
</app-popup-layout>
